import { NavLink } from 'react-router-dom';
import {
  BugIcon,
  BuildingIcon,
  ClipboardListIcon,
  LayoutDashboardIcon,
  MailPlusIcon,
  ScrollTextIcon,
  UsersIcon,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  badge?: number;
}

export function AdminSidebar({ openIssueCount, pendingInviteCount }: {
  openIssueCount?: number;
  pendingInviteCount?: number;
}) {
  const items: NavItem[] = [
    { to: '/admin', label: 'Overview', icon: LayoutDashboardIcon, end: true },
    { to: '/admin/clinics', label: 'Clinics', icon: BuildingIcon },
    { to: '/admin/pipeline', label: 'Pipeline', icon: ClipboardListIcon },
    { to: '/admin/people', label: 'People', icon: UsersIcon },
    { to: '/admin/invitations', label: 'Invitations', icon: MailPlusIcon, badge: pendingInviteCount },
    { to: '/admin/issues', label: 'Issues', icon: BugIcon, badge: openIssueCount },
    { to: '/admin/audit-log', label: 'Audit log', icon: ScrollTextIcon },
  ];

  return (
    <nav className="flex shrink-0 flex-col gap-1 rounded-xl border border-content-highlight/35 bg-content-dark/45 p-2 md:w-56">
      {items.map(({ to, label, icon: Icon, end, badge }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
              isActive
                ? 'bg-primary/15 text-white border border-primary/30'
                : 'border border-transparent text-white/65 hover:bg-content-highlight hover:text-white',
            )
          }
        >
          <Icon className="h-4 w-4 shrink-0" />
          <span className="flex-1 truncate">{label}</span>
          {badge ? (
            <span className="rounded-full bg-amber-500/20 px-2 py-0.5 text-[10px] font-semibold text-amber-200">
              {badge}
            </span>
          ) : null}
        </NavLink>
      ))}
    </nav>
  );
}
